import {ActivityFeed} from './activityFeed';
import {Asset} from './asset';
import {Chat} from './chat';
import {Home} from './home';
import {Organization} from './organization';
import {Personnel} from './personnel';
import {Project} from './project';
import {Calendar} from './calendar';
import {NavigateTo} from './navigate-to';
import {SearchOptions} from './search-options';
import {Tasks} from './tasks';
import {Folder} from './folder';
import {Plus} from './plus';
import {Back} from './back';


export const icons = {
  ActivityFeed,
  Asset,
  Chat,
  Home,
  Organization,
  Personnel,
  Project,
  Calendar,
  NavigateTo,
  SearchOptions,
  Tasks,
  Folder,
  Plus,
  Back,
};

export const SvgIcons = {
  ActivityFeed: 'ActivityFeed',
  Asset: 'Asset',
  Chat: 'Chat',
  Home: 'Home',
  Organization: 'Organization',
  Personnel: 'Personnel',
  Project: 'Project',
  Calendar: 'Calendar',
  NavigateTo: 'NavigateTo',
  SearchOptions: 'SearchOptions',
  Tasks: 'Tasks',
  Folder: 'Folder',
  Plus: 'Plus',
  Back: 'Back',
};



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/index.js